<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiFacilitatorQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="服务商查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">服务商名称：</div>
						<a-input v-model="query.facilitatorName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">服务商编码：</div>
						<a-input v-model="query.facilitatorCode" style="width: 100%;" placeholder="请输入完整的服务商编码" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiFacilitatorQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="facilitatorId" :loading="tableLoading" :pagination="false">
				<span slot="facilitatorName" slot-scope="facilitatorName">
					<a-button type="link" @click="edit(facilitatorName)" >{{facilitatorName.facilitatorName}}</a-button>
				</span>
				<span slot="facilitatorState" slot-scope="facilitatorState">
					<span v-if="facilitatorState == 2">禁用</span>
					<span v-if="facilitatorState == 3">启用</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" >服务商属性</a-button>
				</span>
				
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="服务商名称" has-feedback prop="facilitatorName">
							<a-input v-model="addForm.facilitatorName" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="服务商编码" has-feedback prop="facilitatorCode">
							<a-input v-model="addForm.facilitatorCode" />
						</a-form-model-item>
						<a-form-model-item label="服务商等级" has-feedback prop="facilitatorGrade">
							<a-select v-model="addForm.facilitatorGrade" >
								<a-select-option value="0">未评级</a-select-option>
								<a-select-option value="1">1A景区</a-select-option>
								<a-select-option value="2">2A景区</a-select-option>
								<a-select-option value="3">3A景区</a-select-option>
								<a-select-option value="4">4A景区</a-select-option>
								<a-select-option value="5">5A景区</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="是否启用"  prop="facilitatorState">
							<a-radio-group name="radioGroup" v-model="addForm.facilitatorState">
							    <a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="省" has-feedback prop="provinceId">
							<a-select v-model="addForm.provinceId" @change="regionSelectChange(1)">
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in provinceList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="市" has-feedback prop="cityId">
							<a-select v-model="addForm.cityId" @change="regionSelectChange(2)">
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in cityList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="县/区" has-feedback prop="countyId">
							<a-select v-model="addForm.countyId" >
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in countyList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="详细地址" has-feedback prop="address">
							<a-input v-model="addForm.address" />
						</a-form-model-item>
					</div>
					
					<div class="qa-table-item-3">
						<a-form-model-item label="联系人姓名" has-feedback prop="contactName">
							<a-input v-model="addForm.contactName" />
						</a-form-model-item>
						<a-form-model-item label="联系人电话" has-feedback prop="contactPhone">
							<a-input v-model="addForm.contactPhone" />
						</a-form-model-item>
						<a-form-model-item >
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="介绍" has-feedback prop="introduce">
							<a-textarea placeholder="请输入介绍" :rows="4" v-model="addForm.introduce" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-2">
						<a-form-model-item label="服务商名称" has-feedback prop="facilitatorName">
							<a-input v-model="editForm.facilitatorName" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="服务商编码" has-feedback prop="facilitatorCode">
							<a-input v-model="editForm.facilitatorCode" />
						</a-form-model-item>
						<a-form-model-item label="服务商等级" has-feedback prop="facilitatorGrade">
							<a-select v-model="editForm.facilitatorGrade" >
								<a-select-option value="0">未评级</a-select-option>
								<a-select-option value="1">1A景区</a-select-option>
								<a-select-option value="2">2A景区</a-select-option>
								<a-select-option value="3">3A景区</a-select-option>
								<a-select-option value="4">4A景区</a-select-option>
								<a-select-option value="5">5A景区</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="是否启用"  prop="facilitatorState">
							<a-radio-group name="radioGroup" v-model="editForm.facilitatorState">
							    <a-radio :value="3">是</a-radio>
								<a-radio :value="2">否</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="省" has-feedback prop="provinceId">
							<a-select v-model="editForm.provinceId" @change="editRegionSelectChange(1)">
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in provinceList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="市" has-feedback prop="cityId">
							<a-select v-model="editForm.cityId" @change="editRegionSelectChange(2)">
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in cityList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="县/区" has-feedback prop="countyId">
							<a-select v-model="editForm.countyId" >
								<a-select-option value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in countyList" :value="item.id" :key="index">{{item.title}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="详细地址" has-feedback prop="address">
							<a-input v-model="editForm.address" />
						</a-form-model-item>
					</div>
					
					<div class="qa-table-item-3">
						<a-form-model-item label="联系人姓名" has-feedback prop="contactName">
							<a-input v-model="editForm.contactName" />
						</a-form-model-item>
						<a-form-model-item label="联系人电话" has-feedback prop="contactPhone">
							<a-input v-model="editForm.contactPhone" />
						</a-form-model-item>
						<a-form-model-item >
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="介绍" has-feedback prop="introduce">
							<a-textarea placeholder="请输入介绍" :rows="4" v-model="editForm.introduce" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				provinceList: [],
				cityList: [],
				countyList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					facilitatorName: '',
					facilitatorCode: '',
				},
				tableData: [],
				tableColumns: [{
						title: '服务商ID',
						dataIndex: 'facilitatorId',
						key: 'facilitatorId',
						align: 'center'
					},
					{
						title: '编码',
						dataIndex: 'facilitatorCode',
						key: 'facilitatorCode',
						align: 'center',
						
					},
					{
						title: '服务商名称',
						key: 'facilitatorName',
						align: 'center',
						scopedSlots: {
							customRender: 'facilitatorName'
						}
					},
					{
						title: '状态',
						dataIndex: 'facilitatorState',
						key: 'facilitatorState',
						align: 'center',
						scopedSlots: {
							customRender: 'facilitatorState'
						}
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorCode: '',
					facilitatorName: '',
					facilitatorGrade: '1',
					provinceId: '0',
					cityId: '0',
					countyId: '0',
					contactName: '',
					contactPhone: '',
					address: '',
					facilitatorState: 3,
					introduce: '',
				},
				addRules: {
					facilitatorName: [{ required: true, message: '服务商名称不能为空', trigger: 'blur' }],
					facilitatorCode: [{ required: true, message: '服务商编码不能为空', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					facilitatorId: '',
					facilitatorCode: '',
					facilitatorName: '',
					facilitatorGrade: '1',
					provinceId: '0',
					cityId: '0',
					countyId: '0',
					contactName: '',
					contactPhone: '',
					address: '',
					facilitatorState: 3,
					introduce: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取区域列表
			async apiRegionList(level, parentId) {
				const {data: res} = await this.$http.post(this.navigation.apiRegionList, {parentId: parentId});
				if (res.code == 200) {
					switch(level) {
						case 1:
							this.provinceList = res.data
							break;
						case 2:
							this.cityList = res.data
							break;
						case 3:
							this.countyList = res.data
							break;
					}
					
		
		
				} else {
					this.$message.error(res.msg)
		
				}
			},
			//区域下拉框监听事件
			regionSelectChange(level) {
				switch(level) {
					case 1:
						this.addForm.cityId = '0'
						this.addForm.countyId = '0'
						this.cityList = []
						this.countyList = []
						this.apiRegionList(2, this.addForm.provinceId)
						break;
					case 2:
						this.addForm.countyId = '0'
						this.countyList = []
						this.apiRegionList(3, this.addForm.cityId)
						break;
				}
			},
			//区域下拉框监听事件
			editRegionSelectChange(level) {
				switch(level) {
					case 1:
						this.editForm.cityId = '0'
						this.editForm.countyId = '0'
						this.cityList = []
						this.countyList = []
						this.apiRegionList(2, this.editForm.provinceId)
						break;
					case 2:
						this.editForm.countyId = '0'
						this.countyList = []
						this.apiRegionList(3, this.editForm.cityId)
						break;
				}
			},
			
			async apiFacilitatorQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiFacilitatorQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiFacilitatorQueryList()
			},
			//添加弹窗事件-开始
			tableAdd() {
				this.addVisible = true
				this.cityList = []
				this.countyList = []
			},
			async apiFacilitatorAdd() {
				this.addForm.parentId = this.query.parentId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiFacilitatorQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiFacilitatorAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				if(item.provinceId > 0) this.apiRegionList(2, item.provinceId)
				if(item.cityId > 0) this.apiRegionList(3, item.cityId)
				this.editForm = item
				this.editForm.facilitatorGrade = item.facilitatorGrade + ''
				this.editVisible = true
			},
			async apiFacilitatorEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiFacilitatorQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiFacilitatorEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.facilitatorId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.facilitatorName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiFacilitatorDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiFacilitatorDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorDel, {facilitatorId: this.tableSelectedRows.facilitatorId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiFacilitatorQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.facilitatorId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorQueryList()
			this.apiRegionList(1, 1)
		}
	};
</script>

<style scoped>
	
</style>
